import { useState } from 'react';
import { TextKey, ArticlePath, createGuideLink, RouteName } from '@mews-commander/enums';
import { useResolveRoute } from '@mews/routing';
import { LocalizedText } from '@mews/framework';
import { GeneralEnterprise } from '@mews-commander/data-access';
import { Stack, Tab, Tabs } from '@optimus-web/core';
import { getCurrentEnterprise } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { useCommanderSelector } from '@mews-commander/utils';
import { Breadcrumbs } from '../../../components/BreadcrumbList';
import { BaseLayout } from '../../../components/layout';
import { CancellationPolicies } from '../../cancellationPolicies';
import { SettlementRules } from '../../settlementRules';
import { PaymentPoliciesTabs } from './types';

export const PaymentPoliciesWrapper = () => {
    const resolveRoute = useResolveRoute();

    const enterprise: GeneralEnterprise = useCommanderSelector(getCurrentEnterprise);
    const enterpriseUrl = resolveRoute(RouteName.EnterpriseDetail, { enterpriseId: enterprise.id });

    const [activeTab, setActiveTab] = useState<PaymentPoliciesTabs>(PaymentPoliciesTabs.CancellationPolicies);

    const breadcrumbs: Breadcrumbs = [
        { text: enterprise.name, url: enterpriseUrl },
        {
            text: <LocalizedText textKey={TextKey.GeneralPolicyPlural} />,
            active: true,
        },
    ];

    return (
        <BaseLayout
            breadcrumbs={breadcrumbs}
            guideLink={createGuideLink(
                activeTab === PaymentPoliciesTabs.CancellationPolicies
                    ? ArticlePath.CreateModifyDeleteCancellationPolicy
                    : ArticlePath.HowToSetUpPaymentAutomation
            )}
            padded
        >
            <Stack spacing="200" vertical>
                <Tabs
                    underline
                    inline
                    onTabClick={(_, value) => setActiveTab(value as PaymentPoliciesTabs)}
                    activeTabValue={activeTab}
                >
                    <Tab
                        inline
                        id={PaymentPoliciesTabs.CancellationPolicies}
                        value={PaymentPoliciesTabs.CancellationPolicies}
                        label={<LocalizedText textKey={TextKey.Cancellation} />}
                    />
                    <Tab
                        inline
                        id={PaymentPoliciesTabs.SettlementRules}
                        value={PaymentPoliciesTabs.SettlementRules}
                        label={<LocalizedText textKey={TextKey.Payment} />}
                    />
                </Tabs>
                {activeTab === PaymentPoliciesTabs.SettlementRules ? <SettlementRules /> : <CancellationPolicies />}
            </Stack>
        </BaseLayout>
    );
};
